import { render } from "./mat-menu.vue?vue&type=template&id=2da1830c&scoped=true&lang=true"
import script from "./mat-menu.vue?vue&type=script&lang=js"
export * from "./mat-menu.vue?vue&type=script&lang=js"

import "./mat-menu.vue?vue&type=style&index=0&id=2da1830c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da1830c"]])

export default __exports__